export const locale = {
    lang: 'pl',
    data: {
        'Log details': 'Szczegóły',
        'Close': 'Zamknij',
    }
};
